export function module_analytics() {
	// Google Analytics
	document.write('<script async src="https://www.googletagmanager.com/gtag/js?id=UA-57246019-16"></script>');
	window.dataLayer = window.dataLayer || [];
	function gtag(){
		dataLayer.push(arguments);
	}
gtag('js', new Date());gtag('config', 'UA-57246019-16');
}